<template>
  <div>
    <b-modal
      v-model="show_"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      dialog-class="pb-0"
      hide-footer
    >
      <template #modal-title>
        {{ $t(`${tt}.modal.title`) }}
      </template>

      <h6 class="card-title mb-0">
        {{ $t(`${tt}.modal.description`) }}
      </h6>
      <div class="text-center">
        <button
          type="button"
          :disabled="uploadProcess"
          class="file-upload btn btn-light btn-xl mt-4"
        >
          <i
            class="mr-1 align-middle"
            :class="[uploadProcess ? 'ri-loader-2-line spinner' : 'ri-file-upload-line']"
          />
          {{ $t(`${tt}.modal.btn_upload`) }}
          <input
            ref="file"
            type="file"
            accept="image/*"
            @change="fileUpload"
          >
        </button>
      </div>
      <blockquote
        v-if="!gallery.loading && !gallery.items.length"
        class="blockquote text-center py-2 mt-3 mb-0"
      >
        <div class="mb-3">
          <img
            src="@/static/gallery.png"
            width="50%"
          >
        </div>
        <p
          class="text-muted mb-5"
          v-html="$t(`${tt}.modal.empty_description`)"
        />
      </blockquote>

      <div v-else>
        <div class="pt-4 row">
          <div
            v-for="item of gallery.items"
            :key="`image-${item.id}`"
            class="col-sm-6 col-lg-3"
          >
            <div class="card mb-0">
              <div class="card-img-actions m-1">
                <img
                  :src="`${item.url}_small`"
                  class="card-img img-fluid"
                >

                <div class="card-img-actions-overlay card-img">
                  <a
                    href="#"
                    class="btn btn-outline text-white border-white border-2 btn-icon btn-rounded"
                    @click.prevent="onSelect(item.url)"
                  >
                    <i class="ri-add-line font-size-18 font-weight-bold" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="gallery.totalRows > gallery.perPage"
          class="d-flex justify-content-end"
        >
          <b-pagination
            v-model="gallery.currentPage"
            :hide-goto-end-buttons="true"
            :per-page="gallery.perPage"
            :total-rows="gallery.totalRows"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import catchDispatch from "@/utils/catchDispatch";
import axios from "axios";

const gallery = () => ({
  loading: false,
  items: [],
  perPage: 8,
  totalRows: 0,
  currentPage: 1,
});

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tt: 'room.footer.attach',
    restriction: 'viber',
    uploadProcess: false,
    gallery: gallery(),
  }),
  computed: {
    show_: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
  },
  watch: {
    show_(show) {
      show && this.onShow();
    },
    'gallery.currentPage'() {
      this.fetch();
    },
  },
  methods: {
    onShow() {
      Object.assign(this.gallery, gallery());
      this.fetch();
    },
    fileUpload(e) {
      e.preventDefault();

      if (this.uploadProcess) return;
      this.uploadProcess = true;

      const fileForm = new FormData();
      fileForm.append('restriction', this.restriction);
      fileForm.append('file', e.target.files[0]);

      axios
        .post(`/images/api/v1/images`, fileForm)
        .then(({data: {url}}) => this.onSelect(url))
        .catch(e => {
          this.$refs.file.value = '';
          catchDispatch.call(this, e);
        })
        .finally(() => {
          this.uploadProcess = false;
        });
    },
    fetch() {
      if (this.gallery.loading) return;
      this.gallery.loading = true;

      axios
        .get(`/images/api/v1/images`, {
          params: {
            page: this.gallery.currentPage,
            page_size: this.gallery.perPage,
            order_by: 'created_at desc',
            restriction: this.restriction,
          },
        })
        .then(({data: {Body, Meta: {TotalSize}}}) => {
          this.gallery.items = Body || [];
          this.gallery.totalRows = TotalSize || 0;
        })
        .catch(e => catchDispatch.call(this, e))
        .finally(() => this.gallery.loading = false);
    },
    onSelect(url) {
      this.show_ = false;
      this.$emit('input', {type: 'image', attachment: {url}});
    },
    onReset() {
      if (this.$refs.file) this.$refs.file.value = '';
      this.$emit('input', undefined);
    },
  },
};
</script>

<style scoped>
.file-upload {
  position: relative;
  cursor: pointer;
}

.file-upload input[type=file] {
  -webkit-appearance: none;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}

.card-img-actions {
  position: relative;
}

.card-img-actions:hover .card-img-actions-overlay,
.card-img-actions:focus .card-img-actions-overlay {
  opacity: 1;
  visibility: visible;
}

.card-img-actions-overlay {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  opacity: 0;
  visibility: hidden;
  transition: all ease-in-out 0.15s;
}

@media screen and (prefers-reduced-motion: reduce) {
  .card-img-actions-overlay {
    transition: none;
  }
}

.border-2 {
  border: 2px solid;
}
</style>
